import React, {useState} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {TaskRecurrenceModal} from './TaskRecurrenceModal'

type Props = {
  formikSetFieldValue: (field: string, value: any) => void
  recurrenceData?: any
}

const frequencyLabels: {[key: string]: string} = {
  daily: 'Diário',
  weekdays: 'Dias úteis',
  custom_days: 'Dias personalizados',
  weekly: 'Semanal',
  biweekly: 'Bissemanal',
  monthly: 'Mensal',
  bimonthly: 'Bimestral',
  quarterly: 'Trimestral',
  semiannual: 'Semestral',
  annual: 'Anual',
}

const TaskRecurrence: React.FC<Props> = ({formikSetFieldValue, recurrenceData}) => {
  const [showModal, setShowModal] = useState(false)

  const handleSave = (data: any) => {
    formikSetFieldValue('recurrence', data)
  }

  const getRecurrenceLabel = () => {
    if (!recurrenceData || !recurrenceData.frequency) return null
    return frequencyLabels[recurrenceData.frequency] || recurrenceData.frequency
  }

  const hasRecurrence = recurrenceData && recurrenceData.frequency

  return (
    <>
      <OverlayTrigger
        placement='top'
        overlay={<Tooltip>Configurar recorrência da tarefa</Tooltip>}
      >
        <button
          type='button'
          className='btn btn-sm btn-icon btn-light-primary position-relative'
          onClick={() => setShowModal(true)}
        >
          <i className='bi bi-arrow-repeat fs-4' />
          {hasRecurrence && (
            <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary'>
              <i className='bi bi-check fs-7' />
            </span>
          )}
        </button>
      </OverlayTrigger>

      <TaskRecurrenceModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onSave={handleSave}
        initialData={recurrenceData}
      />
    </>
  )
}

export {TaskRecurrence}
